(function ($) {
  'use strict';

  const initFaq = () => {
    $('.leqee-faq').each(function () {
      const $faq = $(this);
      const $questions = $faq.find('.leqee-faq__question');

      $questions.off('click').on('click', function () {
        const $question = $(this);
        const isExpanded = $question.attr('aria-expanded') === 'true';

        // Close all questions in this FAQ section to act as an accordion
        $questions.attr('aria-expanded', 'false');

        // If the clicked question was not expanded, expand it now
        if (!isExpanded) {
          $question.attr('aria-expanded', 'true');
        }
      });
    });
  };

  $(document).ready(initFaq);

  // Support for Shopify Theme Editor
  $(document).on('shopify:section:load', function () {
    initFaq();
  });
})(jQuery);
